import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
// Caja 3D transparente (6 tomova), Recursos de la tienda ab4b17c0.
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727819999_dzudo-spreman-caja-6-tomova-transparente-baf26cae.webp';
export const heroGuarantees = ['Trenutni digitalni pristup', 'Jednokratna uplata', 'Bez pretplate', '7 dana garancije zadovoljstva'];
export const stats = [{
  value: '240',
  label: 'Strana u šest tomova'
}, {
  value: '6',
  label: 'Digitalnih tomova za trenere džudoa'
}, {
  value: '3',
  label: 'Uzrasne grupe – od 4 do 15 godina'
}, {
  value: '5',
  label: 'Bonusa uključeno'
}, {
  value: '1',
  label: 'Kompletan sistem za trenera'
}];
export const differenceStats = [{
  value: '4–15 godina',
  label: 'Najmlađi, mlađi pioniri i pioniri, mlađi kadeti'
}, {
  value: '6 digitalnih tomova',
  label: 'Od upisa u septembru do polaganja za pojas u junu'
}, {
  value: 'PDF za štampu',
  label: 'Na tabletu ili odštampano – spremno za tatami'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Nedeljne večeri nestaju',
  text: 'Sati za računarom da biste isplanirali treninge za narednu nedelju – i opet niste gotovi.'
}, {
  title: 'Sati traženja',
  text: 'Vežbe sa interneta su prelake, preteške ili ne odgovaraju uzrastu i pojasu dece.'
}, {
  title: 'Svaki trening od nule',
  text: 'Zagrevanje, tehnika, igra i smirivanje – ono što bi trebalo da traje minute postaje ceo posao.'
}, {
  title: 'Različiti pojasevi u grupi',
  text: 'Iskusniji se dosađuju, početnici ne stižu – a vi ste sami na tatamiju.'
}, {
  title: 'Polaganje bez jasnog plana',
  text: 'Šta dete mora da zna za sledeći pojas i kako da ga pripremite na vreme?'
}, {
  title: 'Stres pre treninga',
  text: 'Kad nema vremena, improvizujete i sklapate trening u poslednjem trenutku.'
}];
export const afterItems = ['Uređen godišnji plan za svaku uzrasnu grupu', 'Treninzi od 45 i 60 minuta, minut po minut', '100 igara i igara borbe po uzrastu', 'Tehnika korak po korak: ukemi, držanja, bacanja', 'Program pojaseva od belog do braon pojasa', 'Tri nivoa: početni · srednji · napredni', 'Fizički testovi i praćenje napretka', 'Bezbednost na tatamiju i rad sa roditeljima', 'Plan za celu sezonu – od septembra do juna'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Vikend odlazi na planiranje',
  text: 'Da li deo vikenda provodite u pripremi treninga za narednu nedelju?'
}, {
  icon: FolderSearchIcon,
  title: 'Ne znate koju vežbu da izaberete',
  text: 'Da li stalno tražite igre i vežbe koje odgovaraju uzrastu i pojasu dece?'
}, {
  icon: LightbulbIcon,
  title: 'Želite da objasnite jasnije',
  text: 'Da li vam treba vizuelni materijal da deci jednostavno pokažete pad, držanje ili bacanje?'
}, {
  icon: PencilRulerIcon,
  title: 'Želite da ne pravite sve od nule',
  text: 'Da li biste voleli da su treninzi, testovi i liste za polaganje već spremni?'
}, {
  icon: ShuffleIcon,
  title: 'Deci treba raznovrsnost',
  text: 'Da li želite više igara i izazova da bi cela grupa ostala motivisana do kraja sezone?'
}, {
  icon: LayoutGridIcon,
  title: 'Treba vam jasna struktura',
  text: 'Da li želite sav materijal na jednom mestu i da brzo nađete ono što vam treba?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Tom 01',
  level: '4–15 godina',
  title: 'Godišnji plan i 12 treninga minut po minut',
  tagline: 'Dobar početak sezone.',
  intro: 'Prvi tom vam daje strukturu cele sezone i 12 gotovih treninga – po četiri za svaku uzrasnu grupu.',
  items: ['Godišnji plan za 3 uzrasne grupe', 'Plan po mesecima, od septembra do juna', 'Treninzi od 45 i 60 minuta', '12 treninga minut po minut', 'Svaki trening u 3 nivoa', 'Cilj i pribor za svaki trening', 'Rečenice i komande za trenera', 'Bezbednost na tatamiju', 'Praćenje napretka grupe'],
  outro: 'Izlazite na tatami i tačno znate šta radite.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 02',
  level: '4–15 godina',
  title: 'Banka treninga: 50 gotovih treninga',
  tagline: 'Trening za svaki dan sezone.',
  intro: 'Drugi tom ima 50 gotovih treninga po uzrastu i temi, da nikada ne počinjete od prazne stranice.',
  items: ['Treninzi za najmlađe (4–7)', 'Treninzi za mlađe pionire i pionire (8–11)', 'Treninzi za mlađe kadete (12–15)', 'Ukemi korak po korak', 'Ne-waza i držanja', 'Bacanja za decu', 'Igre i fizička priprema', 'Pred polaganje i pred turnir', 'Otvoreni treninzi za roditelje'],
  outro: 'Otvorite, izaberite i krenite.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 03',
  level: '4–15 godina',
  title: '100 igara i igara borbe u džudou',
  tagline: 'Deca vole da dolaze na trening.',
  intro: 'Treći tom ima 100 igara za zagrevanje, ukemi, rad u parteru i igre borbe u paru, po uzrastu.',
  items: ['Igre za zagrevanje', 'Igre za ukemi i kolutove', 'Igre ravnoteže i koordinacije', 'Igre u parteru', 'Igre borbe u paru', 'Timske igre i štafete', 'Igre za najmlađe', 'Igre za smirivanje', 'Pravila bezbednosti za svaku igru'],
  outro: 'Učenje kroz igru – bez dosade.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 04',
  level: 'Beli – braon pojas',
  title: 'Tehnika korak po korak i program pojaseva',
  tagline: 'Jasan put od belog do braon pojasa.',
  intro: 'Četvrti tom objašnjava tehniku korak po korak i šta dete treba da zna za svaki pojas.',
  items: ['Ukemi: ushiro, yoko, mae, mae-mawari', 'Držanja: kesa, yoko-shiho, kami-shiho, tate-shiho', 'Bacanja: o-goshi, de-ashi-barai, o-soto-otoshi', 'Hvat (kumikata) i kuzushi', 'Česte greške i ispravke', 'Program za svaki pojas', 'Bez poluga i gušenja sa decom', 'Rečnik japanskih izraza', 'Liste za polaganje'],
  outro: 'Svako dete zna šta je sledeći korak.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 05',
  level: '4–15 godina',
  title: 'Bezbednost, vođenje grupe i roditelji',
  tagline: 'Mirna grupa, sigurni treninzi.',
  intro: 'Peti tom vam pomaže da vodite grupu bezbedno i jasno, i da imate dobru saradnju sa roditeljima.',
  items: ['Pravila tatamija', 'Provera tatamija i opreme', 'Bezbedni ukemi i bacanja', 'Prva pomoć i povrede', 'Disciplina bez vikanja', 'Rad sa velikom grupom', 'Poruke za Viber grupu roditelja', 'Roditeljski sastanak', 'Upis i prvi treninzi'],
  outro: 'Vi vodite – grupa sluša.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 06',
  level: '4–15 godina',
  title: 'Praćenje napretka, fizički testovi i polaganje za pojas',
  tagline: 'Napredak koji se vidi.',
  intro: 'Šesti tom vam daje fizičke testove, kriterijume za polaganje i tabele za praćenje svakog deteta.',
  items: ['Fizički testovi po uzrastu', 'Inicijalno i završno testiranje', 'Kriterijumi za svaki pojas', 'Tok polaganja korak po korak', 'Liste za ocenjivanje tehnike', 'Karton džudiste', 'Tabele za praćenje grupe', 'Izveštaj za roditelje', 'Diplome i zahvalnice'],
  outro: 'Polaganje bez stresa – za vas i za decu.',
  note: 'Materijal nije zvanična publikacija Džudo saveza Srbije.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 digitalnih tomova za trenere džudoa',
  text: 'Kompletan program za decu i mlade od 4 do 15 godina koji vam pomaže da planirate i vodite treninge cele sezone. Svaki tom ima 40 strana sa treninzima, igrama, tehnikom i testovima.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Gotovi treninzi',
  text: 'Kraj prazne stranice. Treninzi minut po minut sa komandama za trenera – možete odmah da počnete.'
}, {
  icon: FileTextIcon,
  title: 'Listovi za štampu',
  text: 'Planovi treninga, liste za polaganje i tabele koje odštampate i ponesete na tatami.'
}, {
  icon: ShapesIcon,
  title: 'Vizuelna objašnjenja',
  text: 'Ilustracije, šeme i jednostavna uputstva za svaki pad, držanje i bacanje.'
}, {
  icon: DicesIcon,
  title: 'Igre i igre borbe',
  text: '100 igara u kojima učestvuje cela grupa – od najmlađih do kadeta.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Polaganje bez stresa',
  text: 'Fizički testovi, kriterijumi za svaki pojas i tabele za praćenje svakog deteta.'
}, {
  icon: CalendarCheckIcon,
  title: 'Plan za celu sezonu',
  text: 'Od upisa u septembru do polaganja i letnjeg kampa: ciljevi, teme, igre i testovi.'
}];
// Páginas reales del Tom 01 (págs. 1, 4, 10, 12, 34), WebP en Recursos de la tienda ab4b17c0.
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  { src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727826957_dzudo-spreman-tom01-p01-5599d60d.webp', label: 'Tom 01 · Strana 1', title: 'Naslovna strana', text: 'Godišnji plan i 12 treninga minut po minut – za decu od 4 do 15 godina, spremno za štampu.' },
  { src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727833491_dzudo-spreman-tom01-p04-6b3d2cd3.webp', label: 'Godišnji plan · Strana 4', title: 'Godišnji plan – najmlađi 4–7 godina', text: 'Teme od septembra do juna, sa otvorenim treningom za roditelje, prolećnim turnirom i dodelom pojaseva.' },
  { src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727841909_dzudo-spreman-tom01-p10-5d077a1d.webp', label: 'Trening minut po minut · Strana 10', title: 'Trening 1 · Prvi dan na tatamiju', text: 'Trening od 45 minuta: pozdrav, zagrevanje kroz igru, ukemi, tehnika, igra borbe i smirivanje.' },
  { src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727848719_dzudo-spreman-tom01-p12-9bde7e26.webp', label: 'Trening minut po minut · Strana 12', title: 'Trening 2 · Padam na stranu', text: 'Yoko-ukemi korak po korak, igre, oprema i saveti trenera.' },
  { src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab4b17c0-83e0-431e-b9fc-8848d776a1c7/1793727855474_dzudo-spreman-tom01-p34-40116604.webp', label: 'Organizacija · Strana 34', title: 'Plan tatamija i stanice', text: 'Šema tatamija odozgo sa stanicama, debelom strunjačom i bezbednosnom zonom.' }
];
export const pageTypes = ['Gotovi treninzi', 'Listovi za štampu', 'Igre i igre borbe', 'Polaganje za pojas'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Zamena bez stresa – 12 gotovih treninga za pomoćnog trenera',
  text: 'Grupa nastavlja da trenira i kada vi ne možete da dođete.',
  items: ['12 treninga od 45 ili 60 minuta', 'Po 4 za svaku uzrasnu grupu', 'Rečenice za pomoćnog trenera', 'List za predaju i lista prisustva'],
  benefit: 'Trening se održava i bez vas.'
}, {
  title: 'Zagrevanje za 5 minuta – 60 kartica za štampu',
  text: 'Gotovo zagrevanje za pet minuta, bez pripreme.',
  items: ['60 kartica u četiri kategorije', 'Za uzrast od 4 do 15 godina', '4 kartice po strani za sečenje', '5 gotovih zagrevanja'],
  benefit: 'Deca su u pokretu od prvog minuta.'
}, {
  title: 'Klupski turnir i dan otvorenih vrata korak po korak',
  text: 'Dečji turnir u klubu bez haosa.',
  items: ['Plan pripreme za 6 nedelja', 'Tabele grupa i zapisnik borbe', 'Pravila za decu bez poluga i gušenja', '5 modela diploma'],
  benefit: 'Organizovan događaj – zadovoljni roditelji.'
}, {
  title: 'Komunikacija sa roditeljima – 40 gotovih poruka',
  text: 'Gotove poruke za roditelje za celu sezonu.',
  items: ['40 poruka u 8 celina', 'Upis, polaganje, turnir i kamp', 'Roditeljski sastanak', 'Saglasnost za turnir za štampu'],
  benefit: 'Jasna poruka – za nekoliko minuta.'
}, {
  title: 'Posteri za salu – 15 postera za štampu',
  text: 'Šareni posteri koji organizuju trening.',
  items: ['Pravila tatamija i pozdrav rei', 'Boje pojaseva od belog do braon', 'Moralni kodeks džudoa', 'Reči sudije i četiri ukemija'],
  benefit: 'Sala koja uči i kad ćutite.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Otvorite paket SPREMAN™',
  text: 'Preuzmite paket i otvorite tom za ovu nedelju.'
}, {
  title: 'Izaberite trening',
  text: 'Nađite uzrasnu grupu i temu, pa izaberite trening, igru ili test za svoju grupu.'
}, {
  title: 'Pripremite se za 5 minuta',
  text: 'Pročitajte trening minut po minut i pripremite opremu koja vam treba.'
}, {
  title: 'Odštampajte i počnite',
  text: 'Odštampajte plan ili ga otvorite na tabletu – i izađite na tatami sa jasnim planom.'
}];
export const audienceItems = ['Ste trener ili trenerica džudoa u klubu', 'Radite sa decom i mladima od 4 do 15 godina', 'Vodite grupe sa različitim pojasevima', 'Želite uređen plan za celu sezonu', 'Želite da prestanete da planirate svaki trening od nule', 'Pripremate decu za polaganje za pojas', 'Tražite proverene igre i vežbe', 'Želite da na svaki trening uđete sa gotovim planom'];
export const timeValueTasks = ['Traženje igara i vežbi', 'Pisanje planova treninga', 'Pripremu za polaganje za pojas', 'Izradu testova i tabela za štampu', 'Poruke roditeljima i turnire'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 digitalnih tomova – 240 strana',
  detail: 'Godišnji plan, 50 treninga, 100 igara, tehnika i pojasevi, bezbednost i roditelji, testovi i polaganje'
}, {
  label: '5 bonusa bez dodatnih troškova',
  detail: 'Treninzi za zamenu, kartice za zagrevanje, klupski turnir, poruke roditeljima i posteri za salu'
}, {
  label: 'Za trenere dece od 4 do 15 godina',
  detail: 'Treninzi minut po minut, listovi za štampu, testovi i liste za polaganje'
}];
export const offerIncludes = ['Trenutni digitalni pristup', 'PDF fajlovi koje zadržavate', 'Listovi i tabele za štampu', 'Ne šalje se fizički proizvod'];
export const PRICE = '2.490 din.';
export const COMPARE_PRICE = '5.990 din.'; // espacio duro: el tachado no se parte en 2 líneas en el móvil

// Only add authentic reviews of DŽUDO SPREMAN. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Kako dobijam materijal?',
  a: 'DŽUDO SPREMAN™ je digitalni proizvod. Posle kupovine dobijate pristup PDF fajlovima koje možete da preuzmete i zadržite. Možete ih koristiti na računaru, tabletu ili telefonu i štampati strane koje vam trebaju.'
}, {
  q: 'Da li materijal odgovara klubovima u Srbiji?',
  a: 'Da. Materijal je napravljen za trenere džudoa u klubovima u Srbiji: uzrasne grupe, pojasevi u boji od belog do braon, japanski izrazi džudoa i sezona od septembra do juna. To je nezavisan priručnik – materijal nije zvanična publikacija Džudo saveza Srbije.'
}, {
  q: 'Za koji uzrast je paket?',
  a: 'Za decu i mlade od 4 do 15 godina, u tri grupe: najmlađi (4–7), mlađi pioniri i pioniri (8–11) i mlađi kadeti (12–15). Treninzi imaju tri nivoa: početni, srednji i napredni.'
}, {
  q: 'Mogu li zaista da pripremim trening za 5 minuta?',
  a: 'DŽUDO SPREMAN™ je napravljen da ubrza pripremu. Otvorite tom, izaberete gotov trening i pročitate ga za oko pet minuta. Vreme može da se razlikuje u zavisnosti od grupe i vaših prilagođavanja.'
}, {
  q: 'Ima li dovoljno materijala za celu sezonu?',
  a: 'Da. Šest tomova pokriva celu sezonu, od septembra do juna, sa treninzima, igrama, tehnikom, testovima i polaganjem za pojas. Vi birate, kombinujete i prilagođavate treninge svojoj grupi.'
}, {
  q: 'Ima li listova i tabela spremnih za štampu?',
  a: 'Da. Paket sadrži planove treninga, liste za polaganje, fizičke testove, tabele za praćenje i diplome.'
}, {
  q: 'Da li su treninzi bezbedni za decu?',
  a: 'Da. Svaki trening ima okvir za bezbednost: ukemi uvek pre tehnike, nova bacanja samo na debeloj strunjači, a sa decom nikada poluge ni gušenja.'
}, {
  q: 'Mogu li da ga koristim u grupi sa različitim pojasevima?',
  a: 'Da. Treninzi u tri nivoa omogućavaju da početnici i iskusniji rade na istom treningu, svako svojim tempom.'
}, {
  q: 'Da li moram sve da štampam?',
  a: 'Ne. Štampate samo strane koje vam trebaju, a ostalo možete otvoriti na tabletu ili telefonu u sali.'
}, {
  q: 'Da li je pet bonusa uključeno u cenu?',
  a: `Da. Svih pet bonusa uključeno je u paket bez dodatnih troškova – sve za ${PRICE}`
}, {
  q: 'Da li je ovo pretplata?',
  a: 'Ne. Plaćate jednom i dobijate pristup digitalnom materijalu. Nema mesečnih uplata.'
}, {
  q: 'Mogu li da zadržim fajlove?',
  a: 'Da. PDF fajlove možete da preuzmete i zadržite u skladu sa uslovima korišćenja proizvoda.'
}, {
  q: 'Mogu li da ga koristim na telefonu ili tabletu?',
  a: 'Da. PDF fajlovi se otvaraju na računaru, tabletu i telefonu. Preporučujemo računar ili tablet da proverite izgled pre štampe.'
}, {
  q: 'Postoji li garancija?',
  a: 'Da. DŽUDO SPREMAN™ ima 7 dana garancije zadovoljstva. Ako materijal ne ispuni vaša očekivanja, možete nam pisati u garantnom roku i zatražiti povraćaj novca u skladu sa uslovima.'
}];
export const footerLinks = ['Uslovi prodaje', 'Politika privatnosti', 'Politika povraćaja', 'Kontakt'];
